module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 21.946 21.946",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#pdf",
      toString: function () {
        return this.url;
      }
    }